import {Injectable} from '@angular/core';
import {NestApiProvider} from '../nest-api';
import {Observable} from 'rxjs';

@Injectable()
export class ReportLoryorApi {
  private readonly service: string = 'payroll';
  private readonly model: string = 'reportly1or3';

  constructor(
      private nestApiProvider: NestApiProvider,
  ) {
  }

  public genLy01(filter: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'genLy01';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) urlParams.filter = filter;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestBlobWithProgress(method, url, params, urlParams, body);
  }

  public genLy03(filter: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'genLy03';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) urlParams.filter = filter;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestBlobWithProgress(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/report-loryor.api.ts